import script from "./noticeBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./noticeBar.vue?vue&type=script&setup=true&lang=ts"

import "./noticeBar.vue?vue&type=style&index=0&id=f5b51c0e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5b51c0e"]])

export default __exports__